import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '../lang/en.json';
import jaTranslations from '../lang/ja.json';
import koTranslations from '../lang/ko.json';
import zhHansTranslations from '../lang/zh-Hans.json';
import zhHantTranslations from '../lang/zh-Hant.json';

// Mirrors RN's `localizedAsset` resolution: bare `zh` aliases to the Hans
// variant, specific codes (`zh-Hans`, `zh-Hant`) get their own bundle.
// LanguageContext converts user selection → i18next code via localeMap.json.
const resources = {
  en: { translation: enTranslations },
  ja: { translation: jaTranslations },
  ko: { translation: koTranslations },
  'zh-Hans': { translation: zhHansTranslations },
  'zh-Hant': { translation: zhHantTranslations },
  // Aliases — `localeMap.json` doesn't cover every BCP-47 form the picker
  // can yield (zh-HK, zh-TW, zh-MO, zh-SG…). Map mainland-ish variants to
  // Simplified and TW/HK/MO to Traditional so users land in the right script.
  zh: { translation: zhHansTranslations },
  'zh-CN': { translation: zhHansTranslations },
  'zh-SG': { translation: zhHansTranslations },
  'zh-TW': { translation: zhHantTranslations },
  'zh-HK': { translation: zhHantTranslations },
  'zh-MO': { translation: zhHantTranslations },
  'ja-JP': { translation: jaTranslations },
  'ko-KR': { translation: koTranslations },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  react: {
    useSuspense: false,
  },
  // Return undefined (not the key itself) when a translation is missing,
  // so the `t('FOO') || 'Foo'` fallback pattern actually shows the human
  // string instead of leaking ENUM_KEY into the UI.
  returnNull: true,
  parseMissingKeyHandler: () => undefined as unknown as string,
});

export default i18n;
